import React, { useEffect, useState } from "react";

import Dragger from "antd/lib/upload/Dragger";
import { Button, message, Modal, Spin } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import { customerDocsContTractTypes } from "../../Common/commondata/commonData";
import { transactionLaneDataHandle } from "../state/actions";

import { changeExtensiontoLowerCase, getCoAgentsIds } from "../../Common/utils/ExtraFunctions";
import { Loading } from "../../Common";
import axios from "axios";
import { getPreSignedUrls, uploadFileToS3 } from "../../OfferTable/utils/helper";
import { useFormState } from "react-dom";

export default function UploadPdfDoc({ selectedData, allData, setAllData, handleModalCancel, open, successFuncAll, getCoordinateItem, setIsModalVisible, offerId }) {
  const { loadOpacityLoader } = useSelector((state) => state.app);
  const { offerTableAuthKey } = useSelector((state) => state.offerTable);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const { uploadedPdfDocLoader, uploadedPdfDocSuccess } = useSelector((state) => state.rtdTransactionLane);
  const dispatch = useDispatch();
  function beforeUpload(file) {
    let supportedFormats = file?.type;
    if (supportedFormats?.includes("pdf")) {
      const isPdf = file.type === "application/pdf";
      if (!isPdf) {
        message.error("You can only upload PDF file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        message.error("File must be smaller than 100MB!");
      }
      return isPdf && isLt2M;
    }
  }

  function bytesToSize(bytes) {
    let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  }
  useEffect(() => {
    if (uploadedPdfDocSuccess) {
      handleModalCancel();
      if(setIsModalVisible){
        setIsModalVisible(false); // Close the modal
      }
      setAllData({ ...allData, uploadPdfDoc: false });
      // Reset state if needed
      // if (successFuncAll) {
      //   successFuncAll();
      //   // Run success function if provided
      // }
    }
  }, [uploadedPdfDocSuccess]);
  let handleCustome = (data) => {
    const reader = new FileReader();
    reader.readAsDataURL(data.file);
    reader.onload = () => {};
    reader.onerror = (error) => {
      return error;
    };
    const fileName = changeExtensiontoLowerCase(data?.file?.name);
    const updatedFile = new File([data.file], fileName, {
      type: data.file.type,
      lastModified: data.file.lastModified,
    });

    setAllData({
      ...allData,
      file: updatedFile || data.file,
    });
    setSelectedFile(updatedFile);
  };

  const successFunc = () => {
    if (successFuncAll) {
      successFuncAll();
      setAllData({
        ...allData,
        uploadPdfDoc: false,
      });
    }
  };
  const handleSave = async () => {
    if (!selectedFile) {
      message.error("No file selected for upload.");
      return;
    }
  
    setLoading(true); // Start loader
  
    try {
      const fileName = selectedFile.name;
  
      const preSignedUrls = await getPreSignedUrls({filenames:[fileName],accessToken:offerTableAuthKey,type:"UPLOAD_DOC"});
      const preSignedItem = preSignedUrls?.find((item) => item.fileName === fileName);
  
      if (!preSignedItem?.url) {
        message.error("Failed to generate upload URL.");
        return;
      }
  
      const uploadedFileLink = await uploadFileToS3(selectedFile, preSignedItem.url);
      if (!uploadedFileLink) {
        message.error("File upload failed.");
        return;
      }
  
      setAllData({
        ...allData,
        fileLink: uploadedFileLink,
      });
  
    const contractId = Array.isArray(selectedData?.contractId) ? selectedData.contractId.pop() : selectedData?.contractId;
    const contractType = selectedData?.contractType;
    let unmounted = { value: false };

    const buildData = {
      openFor: selectedData?.RTDInitiator === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
      RTDInitiator: selectedData?.RTDInitiator === "SELLER" ? "SELLER" : "BUYER",
      contractId,
      contractType,
      openForPropertyDoc: selectedData?.RTDInitiator === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
      ...(selectedData?.offerId && contractType !== "NET_SHEET" && { offerId: selectedData.offerId }),
      ...(selectedData?.propertyId && { propertyId: selectedData.propertyId }),
      ...(selectedData?.clientDocId && { clientDocId: selectedData.clientDocId }),
      sellerIds: selectedData?.sellerIds,
      buyerIds: selectedData?.buyerIds,
      buyerAgentIds: getCoAgentsIds(selectedData?.buyerAgentIds),
      sellerAgentIds: getCoAgentsIds(selectedData?.sellerAgentIds),
      fileLink:uploadedFileLink
    };
    dispatch(transactionLaneDataHandle?.uploadPdfDocumentFunc({ data: buildData, successFunc }, offerTableAuthKey, offerId, unmounted));
   
  } catch (error) {
    console.error(error);
    message.error("Something went wrong while uploading.");
   
  } finally {
    setLoading(false);
    setAllData({
      uploadPdfDoc: false,
      file: "",
    })
}
  }

  return (
    <Modal visible={open} onCancel={handleModalCancel} style={{ marginTop: "-50px" }} footer={false} width={700}>
      <div style={{ minHeight: "350px" }}>
        {loadOpacityLoader||loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Centers horizontally
              alignItems: "center", // Centers vertically
              width: "100%",
              height: "50vh", // Full viewport height
            }}
          >
            <Spin />
          </div>
        ) : (
          <div>
            <div style={{ textAlign: "center", fontSize: "1.2rem", padding: "0px 0px 30px 0px" }}>Upload a fully signed PDF document</div>

            <div>
              <Dragger accept=".pdf,.PDF" progress={false} showUploadList={false} customRequest={handleCustome} beforeUpload={beforeUpload}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">Paste, Click or drag file to this area to upload</p>
                <p className="ant-upload-hint">Support for a single document/pdf upload.</p>
              </Dragger>
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                {allData?.file?.name && <h3>{allData?.file?.name}</h3>}
                {allData?.file?.size && <h6>Size: {bytesToSize(allData?.file?.size)}</h6>}
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button type="primary" disabled={!selectedFile} onClick={handleSave}>
                  Done
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
